import React from "react";
import styles from "./tariffs.module.css";

import pdfIcon from "../../files/icons/pdfIcon.png";

class Tariffs extends React.Component {
  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";
    const tipDog = "./Documents/Проект договора с Теплоинформом на услуги ИС ТИ.pdf";
      const tipDogBud = "./Documents/БЮДЖЕТ Проект договора с Теплоинформом на услуги ИС ТИ.pdf";
      const tipDogA = "./Documents/Проект договора с Теплоинформом на услуги и аренду.pdf";
      const tipDogBudA = "./Documents/БЮДЖЕТ Проект договора с Теплоинформом на услуги и аренду.pdf";
    return (
        <div className={styles.container} style={{ marginBottom: firefox ? "3em" : "0em" }}>
            <div style={{ paddingTop: "2vh" }}>
                <img src={pdfIcon} style={{
                    width: "2.4em",
                    height: "auto"
                }} alt="Договор на услуги ИС «Теплоинформ»"/>
                <span style={{ color: "red", paddingLeft: "0.3vw" }}>
                    <a
                        href={tipDog}
                        target="_blank"
                        style={{ paddingLeft: "0.3vw" }}
                        rel="noopener noreferrer"
                    >
                        Договор на услуги ИС «Теплоинформ»
                    </a>
                </span>


            </div>
            <div style={{ paddingTop: "1vh", paddingBottom: "2vh" }}>
                <img src={pdfIcon}
                    style={{
                        width: "2.4em",
                        height: "auto"
                    }} alt ="Договор на услуги ИС «Теплоинформ» для бюджетных организаций"/>
                <span style={{ color: "red", paddingLeft: "0.3vw" }}>
                    <a
                        href={tipDogBud}
                        target="_blank"
                        style={{ paddingLeft: "0.3vw" }}
                        rel="noopener noreferrer"
                    >
                        Договор на услуги ИС «Теплоинформ» для бюджетных организаций
                    </a>
                </span>

            </div>
            <div style={{ paddingTop: "2vh" }}>
                <img src={pdfIcon} style={{
                    width: "2.4em",
                    height: "auto"
                }} alt="Договор на услуги ИС «Теплоинформ» и аренду"/>
                <span style={{ color: "red", paddingLeft: "0.3vw" }}>
                    <a
                        href={tipDogA}
                        target="_blank"
                        style={{ paddingLeft: "0.3vw" }}
                        rel="noopener noreferrer"
                    >
                        Договор на услуги ИС «Теплоинформ» и аренду
                    </a>
                </span>


            </div>
            <div style={{ paddingTop: "1vh", paddingBottom: "2vh" }}>
                <img src={pdfIcon}
                    style={{
                        width: "2.4em",
                        height: "auto"
                    }} alt="Договор на услуги ИС «Теплоинформ» и аренду для бюджетных организаций"/>
                <span style={{ color: "red", paddingLeft: "0.3vw" }}>
                    <a
                        href={tipDogBudA}
                        target="_blank"
                        style={{ paddingLeft: "0.3vw" }}
                        rel="noopener noreferrer"
                    >
                        Договор на услуги ИС «Теплоинформ» и аренду для бюджетных организаций
                    </a>
                </span>

            </div>

        <div className={styles.tariffsTable}>
          <div className={styles.row} style={{ textAlign: "center" }}>
            <div className={styles.cell}>№ п.п</div>
            <div className={styles.cell}>Тарифы (состав услуг)</div>
            <div className={styles.cell}>
              Стоимость в месяц с одной точки учета
            </div>
          </div>
          <a href="#1" id="1" />
          <div className={styles.row}>
            <div
              style={{
                paddingLeft: "1vw",
                textAlign: "center",
                paddingRight: "1vw"
              }}
              className={styles.cell}
            >
              1
            </div>
            <div
              className={styles.cell}
              style={{
                paddingLeft: "1vw"
              }}
            >
              Тарифный план «Учет»
              <ul>
                <li>обеспечение работоспособности Оборудования;</li>
                <li>
                  сбор часовых и суточных архивов с теплосчётчиков каждые сутки;
                </li>
                <li>
                  формирование отчётного документа за месяц (сутки, часы);
                </li>
                <li>
                  формирование документа за месяц (сутки) в формате HTML-XML МОЭК;
                </li>
                <li>
                 контроль работы узла учета тепла раз в сутки (информирование Заказчика
                 о нештатных ситуациях в работе прибора учета
                 и оборудования автоматизированной передачи данных по e-mail);                </li>
                <li>техническая поддержка.</li>
              </ul>
            </div>
            <div style={{ textAlign: "center" }} className={styles.cell}>
              <span>980 руб/месяц</span>
            </div>
          </div>
          <a href="#2" id="2" />
          <div className={styles.row}>
            <div style={{ textAlign: "center" }} className={styles.cell}>
              2
            </div>
            <div
              className={styles.cell}
              style={{
                paddingLeft: "1vw"
              }}
            >
              Тарифный план «Базовый»
              <ul>
                <li>обеспечение работоспособности Оборудования;</li>
                <li>
                  сбор суточных архивов с теплосчётчиков каждые сутки;
                </li>
                <li>
                  сбор часвых архивов с теплосчётчиков каждый час;
                </li>
                <li>
                  чтение текущих значений параметров теплоносителей в реальном
                  времени по запросу пользователя;
                </li>
                <li>
                  контроль работы узла учета тепла раз в сутки (информирование
                  Заказчика о нештатных ситуациях в работе прибора учета и
                  оборудования автоматизированной передачи данных по e-mail и/или telegram);
                </li>
                <li>
                  формирование отчётного документа за месяц (сутки, часы);
                </li>
                <li>
                  формирование документа за месяц (сутки) в формате HTML-XML
                  МОЭК;
                </li>
                <li>техническая поддержка.</li>
              </ul>
            </div>
            <div
              style={{
                paddingLeft: "1vw",
                textAlign: "center",
                paddingRight: "1vw"
              }}
              className={styles.cell}
            >
              1500 руб/месяц
            </div>
          </div>
          <a href="#3" id="3" />
          <div className={styles.row}>
            <div
              style={{
                paddingLeft: "1vw",
                textAlign: "center",
                paddingRight: "1vw"
              }}
              className={styles.cell}
            >
              3
            </div>
            <div
              className={styles.cell}
              style={{
                paddingLeft: "1vw"
              }}
            >
              Тарифный план «Контроль»
              <ul>
                <li>обеспечение работоспособности оборудования;</li>
                <li>сбор часовых архивов с теплосчётчиков каждый час;</li>
                <li>сбор суточных архивов с теплосчётчиков каждые сутки;</li>
                <li>
                  чтение текущих значений параметров теплоносителей в реальном
                  времени по запросу пользователя;
                </li>
                <li>
                  контроль работы узла учета тепла раз в час (информирование
                  Заказчика о нештатных ситуациях в работе прибора учета и
                  оборудования автоматизированной передачи данных по e-mail
                  и/или telegram);
                </li>
                <li>
                  формирование по запросу или в автоматическом режиме отчётного
                  документа за месяц (сутки, часы);
                </li>
                <li>
                  формирование документа за месяц (сутки) в формате HTML-XML
                  МОЭК;
                </li>
                <li>
                  сдача отчетных ведомостей в ПАО «МОЭК», при условии оформления
                  Заказчиком в ПАО «МОЭК» действующей доверенности на
                  Исполнителя;
                </li>
                <li>техническая поддержка.</li>
              </ul>
            </div>
            <div style={{ textAlign: "center" }} className={styles.cell}>
              2000 руб/месяц
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tariffs;
